import { BannerReportInfo } from '../types';

/**
 * 格式化上报拓展字段
 */
export function formatReportInfo(bannerTag?: BannerReportInfo): ({
  fbannertag: string;
} | {
  fext1: string;
  fext2: string;
  fext3: string;
}) {
  if (!bannerTag) return {
    fbannertag: '',
  };
  if (typeof bannerTag === 'string') {
    return {
      fbannertag: bannerTag as string,
    };
  }
  const { ext1 = '', ext2 = '', ext3 = '' } = bannerTag;
  return {
    fext1: ext1,
    fext2: ext2,
    fext3: ext3,
  };
}
